module.exports = __webpack_public_path__ + "static/media/5.9_preview.fd0760b4.png";